import { type GaiaWebSocketResponse, gaiaWsEventBus } from "@expert/gaia";
import type { MessageSuggestion } from "@expert/shared-types";
import { useEffect } from "react";
import { getRootDispatcher } from "@/analytics";
import { useDetectedCuesStore } from "@/sales-tools/detected-cues/stores/DetectedCuesStore";
import { useOfferChecklistStore } from "@/sales-tools/home-product/stores/useOfferChecklistStore";

export const useTechCuesListener = () => {
    useEffect(() => {
        const subscription = gaiaWsEventBus.on("gaia_ws_message-suggestion", ({ body }: GaiaWebSocketResponse) => {
            const gaiaSalesMessage = body as MessageSuggestion;

            if (gaiaSalesMessage.suggestion.cues) {
                const techCues = gaiaSalesMessage.suggestion.cues.filter(
                    (cue) => cue.type === "DEVICE" || cue.type === "SOFTWARE",
                );
                techCues.forEach((cue) => {
                    void getRootDispatcher().dispatchBusinessEvent("CustomerCueDetected", {
                        detectionSource: "GAIA",
                        cueType: cue.type,
                        cueName: cue.name,
                    });
                });

                useDetectedCuesStore.getState().processNewlyDetectedCue(gaiaSalesMessage.sessionGroupId, techCues);
                useOfferChecklistStore.getState().setData(gaiaSalesMessage.sessionGroupId, { DEVICE_CUE: true });
            }
        });
        return () => subscription();
    }, []);
};
